import { change } from 'redux-form';
import { replace } from 'react-router-redux';

import { resetDirty } from 'State/dirtyTracking/actions';
import { handleErrorException, loading, success } from 'State/actions';
import { CREATE_EDIT_TRANSFER_FORM_NAME } from 'Common/FormEnum';
import { CreateEditTransferEnum, FilterEnum } from 'Common/FieldEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getTransferItems = filtersOptions => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CREATE_EDIT_TRANSFER_ITEMS_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Transfer/LoadItems`,
        filtersOptions
      );
      dispatch(success(types.CREATE_EDIT_TRANSFER_ITEMS, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching items. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.TRANSFER_ITEMS_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.CREATE_EDIT_TRANSFER_ITEMS_LOADING, false));
    }
  };
};

export const getTransferDetail = TransferID => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCHING_TRANSFER_DETAIL, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `Transfer/TranferDetails/${TransferID}`
      );
      dispatch(
        success(
          types.SELECTED_TRANSFER_DETAIL,
          response.data.Data['TransferModel']
        )
      );
      dispatch(
        success(
          types.VIEW_TRANSFER_ITEMS,
          response.data.Data['TransferDetailsModel']
        )
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching Transfer Detail. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCHING_TRANSFER_DETAIL_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCHING_TRANSFER_DETAIL, false));
    }
  };
};

export const clearTransferSubmitError = () => {
  return {
    type: types.CLEAR_TRANSFER_ERROR_SUCCESS,
  };
};

export const clearInvalidPreviewData = data => {
  return async dispatch => {
    dispatch(
      change(
        CREATE_EDIT_TRANSFER_FORM_NAME,
        CreateEditTransferEnum.TransferItemsInfo,
        data
      )
    );
  };
};

export const resetFilterOnClickOfPreviousPage = () => {
  return async dispatch => {
    dispatch(
      change(CREATE_EDIT_TRANSFER_FORM_NAME, [FilterEnum.GroupId_Bid], 0)
    );
    dispatch(
      change(CREATE_EDIT_TRANSFER_FORM_NAME, [FilterEnum.GroupId_Item], 0)
    );
  };
};

export const saveTransfer = (model, resetScroll) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SUBMITTING_TRANSFER_DETAIL, true));
    resetScroll();
    model = {
      ...model,
    };
    try {
      await MPWWebApi.postGenericInsertUpdate('Transfer/SaveTransfer', model);
      dispatch(resetDirty());
      dispatch(success(types.TRANSFER_DETAIL_SUBMIT));
      dispatch(replace('/transfer'));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while saving Transfer. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.SUBMIT_TRANSFER_DETAIL_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.SUBMITTING_TRANSFER_DETAIL, false));
    }
  };
};

export const getToSites = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.FETCHING_TRANSFER_DETAIL, true));
      const response = await MPWWebApi.getGeneric(`SiteMaster?allSites=true`);
      dispatch(success(types.GET_TO_SITES, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching sites. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCHING_TRANSFER_DETAIL_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCHING_TRANSFER_DETAIL, false));
    }
  };
};

export const emptyItemList = () => {
  return {
    type: types.CREATE_EDIT_TRANSFER_ITEMS,
    payload: [],
  };
};

export const clearTransferItemGridData = () => {
  return change(
    CREATE_EDIT_TRANSFER_FORM_NAME,
    CreateEditTransferEnum.TransferItemsInfo,
    []
  );
};

export const clearTransferDetails = () => {
  return {
    type: types.SELECTED_TRANSFER_DETAIL,
    payload: null,
  };
};

export const setModifiedTransferItems = data => {
  return change(
    CREATE_EDIT_TRANSFER_FORM_NAME,
    CreateEditTransferEnum.TransferItemsInfo,
    data
  );
};

export const reorderItemList = items => {
  return {
    type: types.RE_TRANSFER_ITEM_LIST,
    payload: items,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/state/createEditTransfer/actions.js